import { Toaster } from 'react-hot-toast';

const CommonToaster = () => {
  return (
    <Toaster
      position="top-center"
      reverseOrder={false}
      gutter={4}
      toastOptions={{
        duration: 5000,
        style: {
          padding: '4px 6px',
          fontSize: '16px',
          fontWeight: 500,
          color: '#64748B',
          borderRadius: '8px',
        },
      }}
    />
  );
};

export default CommonToaster;
